/**
 * Text bent along a curve, filled with a texture. `radius` is the height of the
 * curve in pixels.
 */
import { useId } from 'react';

export interface CircularTextProps {
  text: string;
  textureImg: string;
  radius: number;
}

const Y = 200;
const P1X = 100;
const P2X = 500;
const CX = 300;

export function CircularText({
  text,
  textureImg,
  radius,
}: Readonly<CircularTextProps>) {
  const id = useId();
  const textureId = `texture-${id}`;
  const curveId = `curve-${id}`;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="137 170 330 330"
      style={{ overflow: 'visible' }}
      aria-hidden="true"
    >
      <pattern
        id={textureId}
        patternUnits="userSpaceOnUse"
        width="200"
        height="300"
        x="0"
        y="0"
        viewBox="0 0 200 300"
      >
        <image href={textureImg} width="200" height="300" />
      </pattern>
      <defs>
        <path
          id={curveId}
          d={`M ${P1X} ${Y} Q ${CX} ${Y - radius} ${P2X} ${Y}`}
        />
      </defs>
      <text fill={`url(#${textureId})`}>
        <textPath
          href={`#${curveId}`}
          startOffset="50%"
          style={{ textAnchor: 'middle' }}
        >
          {text}
        </textPath>
      </text>
    </svg>
  );
}
